module.exports = __webpack_public_path__ + "img/Durio_zibethinus.732a956b.jpg";